<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_i"></a>Praise for <em>She May Not Leave:</em></p>
<p class="noindent">“Dry, subversive, and witty, Fay Weldon locks her eye onto every parent’s most neurotic fear and calmly turns the screws.”</p>
<p class="attribution">—Bella Pollen, author of <em>Midnight Cactus</em> and <em>Hunting Unicorns</em></p>
<p class="noindent">“Long a chronicler of the war between the sexes, Weldon takes on motherhood and child rearing. … [Her] trademark acid wit is very much in evidence here, especially on the final pages, which she embellishes with a delicious fillip.”</p>
<p class="attribution">—Tina Jordan, <em>Entertainment Weekly</em></p>
<p class="noindent">“Dry, delicious … Weldon … is far from compassionate—acerbic would be the better word for her clean, clear sentences…”</p>
<p class="attribution">—Carolyn See, <em>The Washington Post</em></p>
<p class="noindent">“Ambitious … interesting … explores the complexity of female relationships, offers an unusual and honest perspective on the history of feminism. Clever … constantly thought provoking read.”</p>
<p class="attribution">—<em>Elle</em></p>
<p class="noindent">“When you are living in domestic hell after your au pair has left, as I am at present, it is comforting to read about your own situation in a Fay Weldon novel. Her voice, at once satirical and sympathetic, is that of an older woman friend whose advice is often as unpalatable as it is invaluable. … Spine chilling black comedy. This witty, wicked, lethally elegant novel about a very modern predicament held me absolutely gripped in between rushing round with a Hoover, a laundry basket, and a frying pan for the children’s tea before working until midnight. It has already been placed on the shelves of my next au-pair’s room.”</p>
<p class="attribution">—Amanda Craig, <em>Daily Telegraph</em></p>
<p class="noindent">“Wickedly hilarious book … fast paced, playful novel. Throughout the book Fay Weldon’s eye for the comic intersections of language and life is an unrepentant kick. In the end of this rollicking shocker of a book, readers will find many themes to warm to.”</p>
<p class="attribution">—Carol Herman, <em>The Washington Times</em></p>
<p class="noindent">“Feminism observer Weldon turns her sharp eye to the desperate neediness of two-career … parents seeking child care. The results hit very close to the working literary family’s bone.”</p>
<p class="attribution">—<em>Publishers Weekly</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Front.vue?c6f75af4